import Vue from 'vue';
import Onboarding from './Onboarding.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import { defaultLocale, messages } from '@/locale';
import VueI18n from 'vue-i18n';

import '@/styles/reset.css';
import '@/styles/element-ui/index.css';
import '@/styles/main.scss';

Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: defaultLocale(),
  messages,
  silentTranslationWarn: true
});

Vue.use(ElementUI, { i18n: (k: any, v: any) => i18n.t(k, v) });

new Vue({
  el: '#onboarding',
  i18n,
  router,
  store,
  render: h => h(Onboarding)
});
